import _ from 'lodash';
import DataService from '../modules/assurance/services/data.service';
import DashboardService from '../modules/assurance/services/dashboard.service';

const DEFAULT_METADATA = [
];

function getMetadataById(fullMetadata, metadataId) {
  let metadata = _.find(fullMetadata, function(metadata) {
    return (metadata.id).toLowerCase() === metadataId.toLowerCase();
  });
  if (!metadata) {
    let defaultMetadata = _.find(DEFAULT_METADATA, function(metadata) {
      return (metadata.id).toLowerCase() === metadataId.toLowerCase();
    });
    if (defaultMetadata) {
      return defaultMetadata;
    }
    throw new Error('No metadata found for id \'' + metadataId + '\'');
  }
  return metadata;
}

const CPMA_FORMATTERS = {};

function convertType(type) {
  if (!type) return 'STRING';
  switch (type) {
    case 'numeric':
    case 'integer':
    case 'currency':
    case 'NUMBER':
      return 'NUMBER';
    case 'percentage':
    case 'PERCENTAGE':
      return 'PERCENTAGE';
    case 'datetime':
    case 'DATETIME':
      return 'none';
    case 'text':
    case 'tag': // TODO: this type applies to the Endpoint Tag column in the settings view. Is converting to "string" here safe?
    case 'string':
    case 'STRING':
      return 'STRING';
    default:
      return 'none';
  }
};

async function convertCpmaColumns(cpmaColumns) {
  const metadata = await DataService.fetchAddCpmaDatasetMetadata();
  let convertedColumns = [];
  cpmaColumns.forEach(column => {
    let item = {
      id: column.columnKey,
      name: column.columnDescription,
      type: convertType(column.datatype),
      format: CPMA_FORMATTERS[column.datatype],
      description: column.columnLongDescription,
      // invisible: !column.uicolumn,
      // hidden: column.defaultFlag
      seq: column.columnSeq ? parseInt(column.columnSeq) : 999,
    };
    updateCpmaColMetadata(metadata, item.id, item); // todo this should be better
    if (column.defaultFlag !== undefined && column.defaultFlag === 0) {
      item.notShown = true; // hidden or invisible?
    }
    convertedColumns.push(item);
  });
  return _.sortBy(convertedColumns, ['seq']); // todo clean this up
}

function updateCpmaColMetadata(metadata, id, item) {
  if (metadata && metadata[id]) {
    Object.assign(item, metadata[id]);
  }
}

export default {
  // With UI-2299 we updated the structure of datasets_metadata.json to include "categories" for some datasets.
  // This method returns the metadata in its original, pre-update structure
  fetchDatasetMetadataWithoutCategories: function(datasetName) {
    let self = this;
    return DataService.fetchDatasetMetadata().then(responseMetadata => {
      if (datasetName) {
        return this.fetchDatasetMetadataForCpmmOrCpma(responseMetadata, datasetName);
      }

      return responseMetadata;
    });
  },

  fetchDatasetMetadata: function(datasetName) {
    return DataService.fetchDatasetMetadata().then(responseMetadata => {
      if (datasetName) {
        return this.fetchDatasetMetadataForCpmmOrCpma(responseMetadata, datasetName);
      }

      return responseMetadata;
    });
  },

  fetchDatasetMetadataForCpmmOrCpma: async function(responseMetadata, datasetName) {
    let datasetMetadata;
    try {
      datasetMetadata = getMetadataById(responseMetadata, datasetName);
    } catch (e) {
      // no matching cpmm dataset, try cpma
      datasetMetadata = {
        id: datasetName,
        // columns: convertCpmaColumns(await DashboardService.fetchFilters({datasetName: datasetName})),
        columns: await convertCpmaColumns(await DashboardService.fetchDatasetColumnsMetadata(datasetName)), // todo split filter metadata call out or merge
        name: datasetName,
      };
    }
    return datasetMetadata;
  },

  fetchDataSourcesMetadata: function() {
    return DataService.fetchDataSourcesMetadata();
  },
  
  // todo this is ugly needing to pass in metadata
  updateCpmaColMetadata: function(metadata, id, item) {
    if (metadata && metadata[id]) {
      Object.assign(item, metadata[id]);
    }
  }

}
